import React, { useState } from "react";
import { Star } from "lucide-react";

/** Interactive 1-5 star rating input.
 *  props: value (1..5), onChange(n), size ("sm"|"md"|"lg"), readOnly.
 */
export default function StarRating({ value = 0, onChange, size = "md", readOnly = false, "data-testid": testId }) {
  const [hover, setHover] = useState(0);
  const px = size === "lg" ? "w-8 h-8" : size === "sm" ? "w-4 h-4" : "w-6 h-6";
  return (
    <div className="inline-flex items-center gap-1" data-testid={testId}>
      {[1, 2, 3, 4, 5].map((n) => {
        const active = (hover || value) >= n;
        return (
          <button
            key={n}
            type="button"
            disabled={readOnly}
            onClick={() => !readOnly && onChange?.(n)}
            onMouseEnter={() => !readOnly && setHover(n)}
            onMouseLeave={() => !readOnly && setHover(0)}
            data-testid={`star-${n}`}
            aria-label={`Rate ${n} out of 5`}
            className={`transition-transform ${readOnly ? "cursor-default" : "cursor-pointer hover:scale-110"}`}
          >
            <Star className={`${px} ${active ? "fill-[#D4AF37] text-[#D4AF37]" : "text-foreground/25"}`} />
          </button>
        );
      })}
    </div>
  );
}
